<div class="container">
  <div class="row product-row">
    <div class="col-9">
      <app-ticket-advanced-configurator></app-ticket-advanced-configurator>
    </div>
    <div class="col-3 ticket">
      <!-- <app-bookin-basket-simple-view></app-bookin-basket-simple-view> -->
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-9">
      <app-backward-forward (backwardClick)="onBackwardClick()" (forwardClick)="onForwardClick()" [forwardError]=""></app-backward-forward>
    </div>
    <div class="col-3">
    </div>
  </div>
</div>
